import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import logo from "../../assets/images/logo.png";
import LoadingImg from "../../assets/images/loading.gif";
import useTrimPath from "../../hooks/useTrimPath/useTrimPath";
import { useLazyGetLoadByIdQuery, useUpdateLoadGoodToGoMutation } from "../../services/load";

const ThanksPage = () => {
	const trimPath = useTrimPath();
	const [searchParams] = useSearchParams();
	const loadId = searchParams.get("tid");
	const [trigger, { data: loadDetails, isFetching: isFetchingLoad }] = useLazyGetLoadByIdQuery();
	const [updateIsGoodToGo, { isFetching: isFetchingGoodToGo }] = useUpdateLoadGoodToGoMutation();
	const isLoading = isFetchingLoad || isFetchingGoodToGo;

	useEffect(() => {
		const fetchData = async () => {
			if (loadId) {
				trigger(loadId);
			}

			if (
				["At PU", "At DO"].includes(loadDetails?.load?.status) &&
				(!loadDetails?.load.goodToGoEnRoute || !loadDetails?.load.goodToGoEnDelivered)
			) {
				try {
					const data = {
						[loadDetails.load.status === "At PU" ? "isBol" : "isPod"]: true,
					};
					await updateIsGoodToGo({
						id: loadId,
						payload: data,
					}).unwrap();
				} catch (error) {
					console.error("Failed to update:", error);
				} finally {
					trimPath();
				}
			}
		};

		fetchData();
	}, [loadId, loadDetails]);

	return (
		<Box
			sx={{
				height: "100vh",
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				alignItems: "center",
				background: "linear-gradient(135deg, #181DD9 30%, #9B8FEF 100%)",
			}}
		>
			<img
				src={isLoading ? LoadingImg : logo}
				alt="Logo"
				style={{
					width: isLoading ? "10%" : "100%",
					maxWidth: "720px",
					height: "auto",
					marginBottom: 20,
				}}
			/>

			<Typography
				variant="h4"
				component="h1"
				sx={{
					color: "white",
					textAlign: "center",
					maxWidth: "720px",
					padding: "20px",
					whiteSpace: "nowrap",
				}}
			>
				{isLoading ? "Updating Data!" : "Thank you! We will keep you updated!"}
			</Typography>
		</Box>
	);
};

export default ThanksPage;
